import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Pagination } from "../../shared/pagination.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { ApiResponseModel, PagingResponseModel } from "../../shared/api-response.model";
import { Core2Config } from "../../shared/core2Config";

import { ApiVisa } from "../../shared/api-visa.model";
import { Observable } from "rxjs";
import { StockLevelMonitoringTemplateHdrModel } from "../../../../../../models/aggregates/erp/stock/stock-level-monitoring-template-hdr.model";

@Injectable({ providedIn: "root" })
export class StockLevelMonitoringTemplateHdrService extends BaseApiTemplateService<StockLevelMonitoringTemplateHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX + "stock-level-monitoring-template-hdrs/" + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "stock-level-monitoring-template-hdrs/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "stock-level-monitoring-template-hdrs/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = theHttp;
  }

  deleteTemplate(
    guid: string,
    deleteType: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      console.log(
        "this.endpoint_path && visa.api_domain_url: ",
        visa.api_domain_url + this.endpoint_path
      );
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + "/" + guid + "?delete_type=" + deleteType,
      this.getHttpHeader(visa)
    );
  }
}
